import React, { useState, useEffect } from "react";

import _ from "lodash";
import { close, tryAgainImg } from "../../assets";
import { Modal } from "react-bootstrap";
import "./Modal.css";
export default ({
  showModal,
  closeModal,
  closeBtnCallBack,
  message,
  closeBtnMessage,
}) => {
  return (
    <>
      <Modal
        show={showModal}
        dialogClassName="modal-dialog modal-dialog-centered modal-sm"
        contentClassName={"customPopup somethingWrong"}
      >
        <button
          type="button"
          className="close"
          onClick={closeModal}
          aria-label="Close"
        ></button>

        <div className="content">
          <div className="modal-caption text-center">
            <h2 className="title title-sm fw--700">
              Oops! <br /> Something Went Wrong
            </h2>
            <img src={tryAgainImg} className="failImg"></img>
            <p>
              {message ?? (
                <>
                  Your request was unsuccessful! <br />
                  Please try again
                </>
              )}
            </p>
          </div>
          <button
            className="custom-btn accent-bg lg w-100"
            onClick={closeBtnCallBack ?? closeModal}
          >
            {closeBtnMessage ?? "Close"}
          </button>
        </div>
      </Modal>
    </>
  );
};
